import { useSelector } from "react-redux";
import { ConfigModel, selectConfig } from "../store/features/configSlice";
import Olark from "react-olark";

/**
 * Olark does not support being inline in the mobile view!
 * This is a workaround to move the olark container
 * to the element with "inlineWrappperId" id!
 * The css of the olark-container is fixed in the main.scss file.
 */
export function fixOlarkToBeInline(inlineWrapperId: string) {
  const olarkFixInterval = setInterval(() => {
    const olarkWrapper = document.getElementById("hbl-live-chat-wrapper");
    const olarkContainer = document.getElementById("olark-container");

    if (!olarkWrapper || !olarkContainer) {
      return;
    }

    if (olarkContainer.classList.contains("olark-hidden")) {
      olarkContainer.classList.remove("olark-hidden");
    }

    const olark = document.getElementById(inlineWrapperId);
    olark?.appendChild(olarkWrapper);
    clearInterval(olarkFixInterval);
  }, 100);
}

export default function InlineOlark() {
  const config: ConfigModel = useSelector(selectConfig);

  if (!config.olarksiteid || !config.olarkgroup) {
    return null;
  }

  return (
    <Olark
      siteId={config.olarksiteid}
      boxConfig={{ start_hidden: false, start_expanded: true }}
      systemConfig={{
        right_to_left: false,
        group: config.olarkgroup,
      }}
    />
  );
}
